import { useState } from "react";
import "./Topbar.css";
import { IoNotificationsOutline } from "react-icons/io5";

const Topbar = ({ vendor }) => {
  const hasNotifications = true;
  const [opennotify, setOpennotify] = useState(false);
  const [imageError, setImageError] = useState(false);

  const profileUrl = vendor?.profile
    ? `${process.env.REACT_APP_BASEURL}/apis/uploads/profile/${vendor.profile}`
    : null;
  const showImage = profileUrl && !imageError;

  return (
    <div className="topbar">
      <div className="topbar-right">
        {/* Notification Icon */}
        <div
          className="notification-wrapper"
          onClick={() => setOpennotify(true)}
        >
          <IoNotificationsOutline className="notification-icon" />
          {hasNotifications && <span className="notification-dot" />}
        </div>

        <div className="welcome-text">
          <p className="greeting">Welcome back,</p>
          <p className="vendor-name">{vendor?.vendor_name}</p>
        </div>
        <div className="profile-avatar" title="Vendor Profile">
          {showImage ? (
            <img
              src={profileUrl}
              alt="Vendor Profile"
              className="profile-avatar-img"
              onError={() => setImageError(true)}
            />
          ) : (
            <span>{vendor?.vendor_name?.charAt(0)?.toUpperCase() || ""}</span>
          )}
        </div>
      </div>

      {opennotify && (
        <div className="notify-floating" id="notifyBox">
          <button className="close-btn" onClick={() => setOpennotify(false)}>
            ×
          </button>
          <h3>🔔 Notifications</h3>
          <ul>
            <li>Order #1234 has been shipped.</li>
            <li>New message from support.</li>
            <li>Stock low on Product A.</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Topbar;
